import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toInteger, isEmpty } from 'lodash';

import { PATH } from '../../../../constants/path';
import directoryService from '../../../../services/directory';

import { clearFilter, filterPartnerOnCategory } from '../../../../services/filter/actions';

import { formatCategoryNameForUrl } from '../../../../services/category/utils';
import { buildPathPrefix } from '../../../../utils/directoryUtils';

import SortSelectComponent from './SortSelectComponent';
import ButtonComponent from '../../../button/ButtonComponent';
import NumberDisplayComponent from './NumberDisplayComponent';
import CategorySelectComponent from './CategorySelectComponent';

import './FilterComponent.scss';

class FilterComponent extends React.Component {
    state = {
        isReset: false // Ajout de l'état pour suivre la réinitialisation du bouton
    };

    buildPathPrefix = () =>
        buildPathPrefix(
            this.props.locale,
            this.props.isCodePromo,
            this.props.isOffline,
            this.props.isEbon
        );

    componentDidMount() {
        // Vérifier l'URL lors du chargement initial
        this.checkURLReset();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            // Vérifier l'URL lors d'un changement d'URL
            this.checkURLReset();
        }
    }

    checkURLReset() {
        // Récupération du chemin d'accès de l'URL actuelle
        const { pathname } = this.props.location;

        // Définition des chemins qui entraîneront la réinitialisation du bouton
        const resetPaths = [
            `/${PATH.ALPHA_PATH}/:letter`, // Chemin avec une lettre spécifique
            `/${PATH.CATEGORY_PATH}/:categoryName-:categoryId`, // Chemin avec une catégorie spécifique
            `/${PATH.MOST_POPULAR_PATH}` // Chemin des plus populaires
        ];

        // Vérification si le chemin actuel correspond à l'un des chemins de réinitialisation
        const isReset = resetPaths.some(path => pathname.includes(path));

        // Mise à jour de l'état "isReset" en fonction du résultat de la vérification
        this.setState({ isReset });
    }

    /**
     * Click handler Button A-Z
     */
    onClickBtTriAZ = e => {
        e.preventDefault();
        this.props.clearFilter('directory');
        this.props.history.push(
            `${this.buildPathPrefix()}/${PATH.ALPHA_PATH}/${
                directoryService.constants.ABCBOOK_DEFAULT_LETTER
            }`
        );
    };

    /**
     * Change handler on Category select
     * @param {Integer} id
     */
    onChangeCategory = id => {
        const { categories, history } = this.props;

        if (toInteger(id) > 0) {
            const category = categories.filter(curr => toInteger(curr.id) === toInteger(id))[0];

            // on change l'url pour qu'elle matche avec le choix de la catégorie
            // les dispatch pour changer le store se font dans componentWillReceiveProps d'AnnuairePage
            if (!isEmpty(category)) {
                history.push(
                    `${this.buildPathPrefix()}/${PATH.CATEGORY_PATH}/${formatCategoryNameForUrl(
                        category.label
                    )}-${category.id}`
                );
            }

            this.props.filterPartnerOnCategory('directory', Number(category.id));
        } else {
            history.push(`${this.buildPathPrefix()}/${PATH.MOST_POPULAR_PATH}`);
            this.props.clearFilter('directory');
        }
    };

    render() {
        const {
            i18n,
            partners,
            isCodePromo,
            categories,
            categoryId,
            isOffline,
            isEbon
        } = this.props;
        const { isReset } = this.state;

        return (
            <form className="annuaire-filtre flex-container-h flex-center-alt">
                <NumberDisplayComponent partners={partners} isCodePromo={isCodePromo} />
                <div className="filtre-conteneur flex-container-h flex-center-alt">
                    <CategorySelectComponent
                        categories={categories}
                        categoryId={categoryId}
                        onChangeCategory={this.onChangeCategory}
                    />
                    <ButtonComponent
                        text={
                            <React.Fragment>
                                <span className="sr-only">{i18n.AZ_BUTTON_LABEL} </span>A-Z
                            </React.Fragment>
                        }
                        color="sixth"
                        onClick={this.onClickBtTriAZ}
                        cssClass={`bt-az ${isReset ? 'reset' : ''}`}
                    />
                    <SortSelectComponent
                        categories={categories}
                        isCodePromo={isCodePromo}
                        isOffline={isOffline}
                        isEbon={isEbon}
                    />
                </div>
            </form>
        );
    }
}

FilterComponent.propTypes = {
    partners: PropTypes.array,
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    categories: PropTypes.array.isRequired,
    categoryId: PropTypes.number.isRequired
};

const mapDispatchToProps = {
    filterPartnerOnCategory,
    clearFilter
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.DIRECTORY,
        locale: state.i18n.locale
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterComponent));



// WEBPACK FOOTER //
// ./src/components/pages/directory/filter/FilterComponent.js